import "./our-works-section.css"
import { useEffect, useState } from "react";
import { ourWorkData } from "../../data/OurWorkData"
import WorkCard from "../work-card/WorkCard"

function OurWorksSection({ workPageId }) {
    const [plusIndex, setPlusIndex] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            setPlusIndex(window.innerWidth <= 768 ? 2 : 3);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const currentIndex = ourWorkData.findIndex(work => work.id === workPageId);
    const result = [];

    for (let i = 1; i < plusIndex; i++) {
        const nextIndex = (currentIndex + i) % ourWorkData.length;
        result.push(ourWorkData[nextIndex]);
    }

    return (
        <div className="our-works-section">
            <div className="our-works-section-header">
                <h1>
                    <span className="bold">Our</span> Works
                </h1>
                <div className="our-works-section-header-border"></div>
            </div>

            <div className="our-works-content">
                {result.map((work) =>
                    <WorkCard key={work.id} data={work} />
                )}
            </div>
        </div>
    )
}

export default OurWorksSection
